import {
    TALLY_SET_LOCK,
    TALLY_SET_PICI_GOODS_NUM,
    TALLY_SET_UPSHELE_NO,
    TALLY_SET_BOX_NO,
    TALLY_SET_BLP_BOX_NO,
    TALLY_SET_NO_DATA_BOX_NO,
    TALLY_SET_SUIT_PARTS_BOX_NO
} from "../mutation-types";
const tally = {
    state: {
        pici_goods_num: 0,
        lock: false,
        us_no: "",
        box_no: "",
        blp_box_no: "",
        no_data_box_no: "",
        suit_parts_box_no: ""
    },
    mutations: {
        [TALLY_SET_PICI_GOODS_NUM]: (state, num) => {
            if (num === "undefined" || isNaN(parseInt(num))) {
                state.pici_goods_num = 0;
            } else {
                state.pici_goods_num = parseInt(num);
            }
        },
        [TALLY_SET_LOCK]: (state, lock) => {
            state.lock = lock;
        },
        [TALLY_SET_UPSHELE_NO]: (state, us_no) => {
            state.us_no = us_no;
        },
        [TALLY_SET_BOX_NO]: (state, box_no) => {
            state.box_no = box_no;
        },
        [TALLY_SET_BLP_BOX_NO]: (state, box_no) => {
            state.blp_box_no = box_no;
        },
        [TALLY_SET_NO_DATA_BOX_NO]: (state, box_no) => {
            state.no_data_box_no = box_no;
        },
        [TALLY_SET_SUIT_PARTS_BOX_NO]: (state, box_no) => {
            state.suit_parts_box_no = box_no;
        }
    },
    actions: {
        setPiciGoodsNum({ commit }, num) {
            commit(TALLY_SET_PICI_GOODS_NUM, num);
        },
        setLock({ commit }, lock) {
            commit(TALLY_SET_LOCK, lock);
        },
        setUpsheleNo({ commit }, us_no) {
            commit(TALLY_SET_UPSHELE_NO, us_no);
        },
        setBoxNo({ commit }, box_no) {
            commit(TALLY_SET_BOX_NO, box_no);
        },
        setBlpBoxNo({ commit }, box_no) {
            commit(TALLY_SET_BLP_BOX_NO, box_no);
        },
        setNoDataBoxNo({ commit }, box_no) {
            commit(TALLY_SET_NO_DATA_BOX_NO, box_no);
        },
        setSuitPartsBoxNo({ commit }, box_no) {
            commit(TALLY_SET_SUIT_PARTS_BOX_NO, box_no);
        }
    }
};
export default tally;



// WEBPACK FOOTER //
// ./src/store/modules/tally.js